import React, { useContext, useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DataContext from './DataContext';
import TextBlock from './blocks/TextBlock';
import DropdownBlock from './blocks/DropdownBlock'
import GetAddress from './blocks/GetAddress';
import NumberBlock from './blocks/NumberBlock';
import axios from 'axios';
import {config} from '../../utils/config';
import ImageUpload from './ImageUpload';

export default function AddProperty() {

    const formData = useContext(DataContext)
    const navigate = useNavigate()
    const [data, setData] = useState(null);
    const [page1, setPage1] = useState(true);
    const [page2, setPage2] = useState(false);
    const [page3, setPage3] = useState(false);
    const [page4, setPage4] = useState(false);

    const toPage2 = useCallback(() => {
        setPage1(false)
        setPage2(true)
        setPage3(false)
        setPage4(false)
    }, [])

    const toPage1 = useCallback(() => {
        setPage1(true)
        setPage2(false)
        setPage3(false)
        setPage4(false)
    }, [])

    const toPage3 = useCallback(() => {
        setPage1(false)
        setPage2(false)
        setPage3(true)
        setPage4(false)
    }, [])

    const toPage4 = useCallback(() => {
        setPage1(false)
        setPage2(false)
        setPage3(false)
        setPage4(true)
    }, [])


    const postPropertyData = useCallback(async () => {
        // withCredentials is to send session/cookie info to server
        const result = await axios.post(`${config.apiBaseUrl}/createlisting`, data, { withCredentials: true })
        // console.log(result)
        if(result.data === "property and listing added" || result.data === "listing added"){
            toPage4()
        }else{
            console.log("error")
        }

    }, [data, toPage4])

    useEffect(() => {

        // updating property data
        const propertyData = formData.getPropertyData()
        const listingData = formData.getListingData()
        const mediaData = formData.getMediaData()
        setData([...propertyData, ...listingData, { ...[mediaData] }])

    }, [formData])


    return (
        <>
            <div className="container-fluid p-1" style={{ width: "90%" }}>

                <div className="container" style={{ display: page1 ? 'block' : 'none' }}>

                    <div className="progress mb-3" style={{ height: "20px" }}>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment one" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">Building Details</div>
                    </div>

                    <GetAddress label={formData.getFormLabel().map((d) => { return d.formBlockTitle2 })}
                        updateParentValue={(value) => { formData.updatePropertyData("fullAddressData", value) }} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle3 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray3) })}
                        updateParentValue={(value) => { formData.updatePropertyData("propertyTypeValue", value) }} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle4 })}
                        option={
                            formData.getDropdownData().map((d) => { return (d[formData.getPropertyData().map((d) => { return (d.propertyTypeValue) })]) })
                        }
                        updateParentValue={(value) => { formData.updatePropertyData("propertySubTypeValue", value) }} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle11 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray4) })}
                        updateParentValue={(value) => { formData.updatePropertyData("tenureValue", value) }} />

                    <TextBlock type={"date"} label={formData.getFormLabel().map((d) => { return d.formBlockTitle12 })}
                        updateParentValue={(value) => { formData.updatePropertyData("wefValue", value) }} />

                    <TextBlock type={"date"} label={formData.getFormLabel().map((d) => { return d.formBlockTitle13 })}
                        updateParentValue={(value) => { formData.updatePropertyData("topValue", value) }} />

                    <div>
                        <button className="btn btn-danger" onClick={toPage2}>Next</button>
                    </div>
                </div>


                <div className="container" style={{ display: page2 ? 'block' : 'none' }}>

                    <div className="progress mb-3" style={{ height: "20px" }}>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment one" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">Building Details</div>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment two" style={{ width: "25%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">Property Details</div>
                    </div>

                    <TextBlock type={"text"} label={formData.getFormLabel().map((d) => { return d.formBlockTitle14 })}
                        updateParentValue={(value) => { formData.updateListingData("unitValue", value) }} />

                    {formData.getPropertyData().map((d) => d.propertyTypeValue).some((value) => ["Condo", "HDB", "Landed"].includes(value)) ? (
                        <DropdownBlock label={formData.getFormLabel().map((d) => d.formBlockTitle19)}
                            option={formData.getDropdownData().map((d) => { return (d.formBlockArray8) })}
                            updateParentValue={(value) => { formData.updateListingData("roomNoValue", value) }} />) : null
                    }

                    {formData.getPropertyData().map((d) => d.propertyTypeValue).some((value) => ["Condo", "HDB", "Landed"].includes(value)) ? (
                        <DropdownBlock label={formData.getFormLabel().map((d) => d.formBlockTitle20)}
                            option={formData.getDropdownData().map((d) => { return (d.formBlockArray9) })}
                            updateParentValue={(value) => { formData.updateListingData("bathNoValue", value) }} />) : null
                    }

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle1 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray1) })}
                        updateParentValue={(value) => { formData.updateListingData("listingTypeValue", value) }} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle10 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray2) })}
                        updateParentValue={(value) => { formData.updateListingData("listingSubTypeValue", value) }} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle15 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray5) })}
                        updateParentValue={(value) => { formData.updateListingData("termValue", value) }} />


                    <NumberBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle6 })}
                        updateParentValue={(value) => { formData.updateListingData("sizeBuiltValue", value) }} suffix={" sqft"} />


                    {formData.getPropertyData().map((d) => d.propertyTypeValue).some((value) => ["Landed", "Retail", "Industrial", "Land"].includes(value)) ? (
                        <NumberBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle7 })}
                            updateParentValue={(value) => { formData.updateListingData("sizeLandValue", value) }} suffix={" sqft"} />) : null
                    }

                    <NumberBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle8 })}
                        updateParentValue={(value) => { formData.updateListingData("priceValue", value) }} prefix={"$"} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle16 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray6) })}
                        updateParentValue={(value) => { formData.updateListingData("priceStateValue", value) }} />

                    <div className="d-flex justify-content-between">
                        <button className="btn btn-danger" onClick={toPage1}>Back</button>
                        <button className="btn btn-danger" onClick={toPage3}>Next</button>
                    </div>

                </div>

                <div className="container" style={{ display: page3 ? 'block' : 'none' }}>

                    <div className="progress mb-3" style={{ height: "20px" }}>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment one" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">Building Details</div>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment two" style={{ width: "25%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">Property Details</div>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment two" style={{ width: "25%" }} aria-valuenow="750" aria-valuemin="0" aria-valuemax="100">More Details</div>
                    </div>

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle17 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray7) })}
                        updateParentValue={(value) => { formData.updateListingData("gstValue", value) }} />

                    <NumberBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle18 })}
                        updateParentValue={(value) => { formData.updateListingData("maintFeeValue", value) }} prefix={"$"} suffix={" /quarter"} />

                    <TextBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle9 })}
                        updateParentValue={(value) => { formData.updateListingData("headlineValue", value) }} />

                    <TextBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle5 })}
                        updateParentValue={(value) => { formData.updateListingData("descriptionValue", value) }} />

                    <div>
                        <ImageUpload />
                    </div>

                    <div className="d-flex justify-content-between">
                        <button className="btn btn-danger" onClick={toPage2}>Back</button>
                        <button className="btn btn-danger" onClick={postPropertyData}>Submit</button>
                    </div>
                </div>

                <div className="container" style={{ display: page4 ? 'block' : 'none' }}>

                    <div className="progress mb-3" style={{ height: "20px" }}>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment four" style={{ width: "100%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">Added Successfully!</div>
                    </div>

                    <div className="container">
                        <h5>Added Successfully!</h5>
                    </div>
                    <div>
                        <button className="btn btn-danger" onClick={()=>navigate("/agent/dashboard")}>To Dashboard</button>
                    </div>
                </div>

            </div>
        </>
    )

}


